import { useEffect, useState } from "react";

function getMainElement() {
  return document.getElementById("main");
}

export const useOnScroll = (
  callbackFn: (e: Event) => void,
  ref?: React.RefObject<HTMLElement | null>,
): {
  scrollTop: number;
} => {
  // oxlint-disable-next-line react-hooks/refs
  const element = ref?.current ?? getMainElement();
  const [scrollTop, setScrollTop] = useState(element?.scrollTop ?? 0);

  useEffect(() => {
    const element = ref?.current ?? getMainElement();

    if (element) {
      const handler = (e: Event) => {
        setScrollTop(element.scrollTop);
        callbackFn(e);
      };

      element.addEventListener("scroll", handler);

      return () => {
        element.removeEventListener("scroll", handler);
      };
    }
  }, [callbackFn, ref]);

  return {
    scrollTop,
  };
};
